import type {TypographyVariantsOptions} from "@mui/material/styles"

const typography: TypographyVariantsOptions = {
	h6: {
		fontWeight: 700,
	},
	button: {
		textTransform: "none",
	},
}

const typographyNewLandingPage: TypographyVariantsOptions = {
	fontFamily: ["Manrope", "Roboto", "sans-serif"].join(","),
	h6: {
		fontWeight: 700,
	},
	button: {
		textTransform: "none",
	},
	subtitle2: {
		lineHeight: "1.25rem",
		fontWeight: 400,
	},
}

export {typography, typographyNewLandingPage}
